var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentLikes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 4.34443C0.664076 3.60256 0.889125 2.87815 1.30948 2.26687C1.72984 1.65559 2.32574 1.1862 3.01847 0.920694C3.7112 0.655188 4.46817 0.606057 5.1894 0.779791C5.91064 0.953524 6.56221 1.34195 7.05806 1.89376C7.09299 1.9311 7.13521 1.96087 7.18211 1.98123C7.22902 2.00158 7.2796 2.01208 7.33073 2.01208C7.38186 2.01208 7.43244 2.00158 7.47935 1.98123C7.52625 1.96087 7.56847 1.9311 7.6034 1.89376C8.09769 1.33836 8.74941 0.946673 9.47182 0.770829C10.1942 0.594985 10.9531 0.643326 11.6473 0.909417C12.3416 1.17551 12.9383 1.64673 13.3581 2.26036C13.778 2.874 14.0009 3.60093 13.9974 4.34443C13.9974 5.87109 12.9974 7.01109 11.9974 8.01109L8.33606 11.5531C8.21184 11.6958 8.05868 11.8104 7.88676 11.8893C7.71484 11.9682 7.52809 12.0097 7.33892 12.0109C7.14975 12.0121 6.96249 11.973 6.78959 11.8962C6.61668 11.8195 6.46208 11.7068 6.33606 11.5658L2.66406 8.01109C1.66406 7.01109 0.664062 5.87776 0.664062 4.34443Z",
    stroke: "#6B6B6B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentLikes);
export default __webpack_public_path__ + "static/media/sent-likes.3ceebacb3d6ce97b4f77fb72f21b4288.svg";
export { ForwardRef as ReactComponent };